module.exports = __webpack_public_path__ + "img/e_charger_enabled.84db8dd1.svg";